const NATIONAL_PHONE_DIGITS = /^[2-9]\d{9}$/;
/** the 10 national digits of a US/Canada number in any common spelling ("(415) 555-4821", "+1 415 555 4821", "14155554821"); null for anything else */
export function toNationalPhoneDigits(value) {
    const digits = value.replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '');
    return NATIONAL_PHONE_DIGITS.test(digits) ? digits : null;
}
